module.exports = __webpack_public_path__ + "static/media/lora_modbus.2f76debd.md";